import { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Config from "../../Config";

function SellerProductTableRow({ product, onRefresh }) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete "${product.name}"?`)) return;
    setIsDeleting(true);
    try {
      const response = await fetch(`${Config.apiUrl}/products/${product.id}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to delete product");
      toast.success("Product deleted successfully");
      onRefresh();
    } catch (error) {
      toast.error("Failed to delete product");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleEdit = async () => {
    if (!window.confirm(`Are you sure you want to edit "${product.name}"?`)) return;
    setIsEditing(true);
    try {
      const response = await fetch(`${Config.apiUrl}/products/${product.id}`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to edit product");
      toast.success("Product edited successfully");
      onRefresh();
    } catch (error) {
      toast.error("Failed to edit product");
    } finally {
      setIsEditing(false);
    }
  };

  const imageUrl = product.images?.[0]?.url || product.image || "https://via.placeholder.com/100";

  return (
    <tr className="border-b border-gray-200 text-sm text-gray-700">
      <td className="p-3">
        <img src={imageUrl} alt={product.name} className="w-16 h-16 object-cover rounded" />
      </td>
      <td className="p-3 font-medium">{product.name}</td>
      <td className="p-3">{product.brand || "-"}</td>
      <td className="p-3 text-green-600 font-semibold">₹{product.price}</td>
      <td className="p-3">
        {product.stock_quantity > 0 ? (
          <span className="text-green-600">In Stock ({product.stock_quantity})</span>
        ) : (
          <span className="text-red-500">Out of Stock</span>
        )}
      </td>
      <td className="p-3">{product.category_id || "-"}</td>
      <td className="p-3">{product.sku || "-"}</td>
      <td className="p-3">{product.slug || "-"}</td>
      <td className="p-3">
        <div className="flex gap-2">
          <button
            onClick={handleEdit}
            disabled={isEditing}
            className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
          >
            {isEditing ? "Editing..." : "Edit"}
          </button>
          <button
            onClick={handleDelete}
            disabled={isDeleting}
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </td>
    </tr>
  );
}

export default SellerProductTableRow;
